var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"begin Center"},[_c('div',{staticClass:"beginBox"},[_c('img',{staticClass:"wid100",attrs:{"src":require("../assets/1/begin.png"),"alt":""}}),_vm._v(" "),_c('div',{staticClass:"btn"},[_c('img',{staticClass:"wid100",attrs:{"src":require("../assets/btn/begin.png"),"alt":""},on:{"click":_vm.handleClose}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8f1db80c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/begin.vue
// module id = null
// module chunks = 